"use strict";

angular.module("vendor")
.service("CustomerManagementService", function(
    $resource, FlashBag, gettextCatalog, common, CustomerFinancialService, appConfig,
    PartnershipSelectorUnregisteredServiceFactory
) {
    const LISTING_URL = "/auth/vendor/partnerships/list/";

    function CustomerManagementService() {
        PartnershipSelectorUnregisteredServiceFactory.call(this, LISTING_URL);

        this.getBulkActionParams = function() {
            var financialActionParams = CustomerFinancialService.getBulkActionParams();
            var deleteResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/delete/");

            return {
                credit_limit_block: financialActionParams["credit_limit_block"],
                credit_limit_warning: financialActionParams["credit_limit_warning"],
                overdue_block: financialActionParams["overdue_block"],
                overdue_warning: financialActionParams["overdue_warning"],
                update_allowed_payment_methods: financialActionParams["update_allowed_payment_methods"],
                update_allowed_pre_authorized_payment_methods: financialActionParams["update_allowed_pre_authorized_payment_methods"],
                update_pre_authorized_payment_agreement_type: financialActionParams["update_pre_authorized_payment_agreement_type"],
                delete: {
                    text: gettextCatalog.getString("Delete"),
                    message: gettextCatalog.getString("Do you really want to delete these customers?"),
                    resource: deleteResource,
                    successMessage: gettextCatalog.getString("Customers were deleted successfully. Customers shared with an authorized catalog were not deleted."),
                    modalTemplatePrefix: "partnership",
                    modalTemplatePackage: "vendor"
                }
            };
        };

        this.getSingleActionParams = function() {
            return this.getBulkActionParams();
        };

        this.getSortFields = function() {
            return common.getSortFieldsByKeys(
                "company_name, buyer_number, status_date",
                this.getAvailableSortFields()
            );
        };

    }

    return new CustomerManagementService();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/customer-manage.service.js
// module id = 867
// module chunks = 0